// Production environment configuration
export const environment = {
  production: true,
  apiBaseUrl: 'https://api.framework.sparkbusinesstechnology.com.au/prd', // Update this with your production API Gateway URL
  stripePublishableKey: 'pk_live_51SeZJV88ystbcOhgwrMx3e9TZVGtYzcj0r2d9X2hLVKehSPFJsMbvMWXCsh0KDBJIjqKZBkth3JWx74pQ8SFDUk000iX5HBZmM',
  appName: 'YomConnect AI Admin',
  version: '1.0.0'
};
